import React from 'react';
import { images } from '../../data/images';
interface TileProps {
  image: string;
  alt: string;
  title: string;
  text: string;
  className?: string;
  stat?: {
    value: string;
    label: string;
  };
}
function ImageTile({
  image,
  alt,
  title,
  text,
  className = '',
  stat
}: TileProps) {
  return <article className={`relative min-h-[380px] overflow-hidden rounded-[28px] bg-forest ${className}`} data-id="element-45" data-mp="2gbil977z4wfo">
      <img src={image} alt={alt} className="absolute inset-0 h-full w-full object-cover" data-id="element-46" data-mp="3dzivpu72h4yz" />
      <div className="absolute inset-x-3 bottom-3 rounded-2xl bg-ink/75 p-5 text-canvas backdrop-blur-md sm:inset-x-4 sm:bottom-4 sm:p-6" data-id="element-47" data-mp="39061godv8vmd">
        <div className="flex items-end justify-between gap-6" data-id="element-48" data-mp="33zi83w2602oz">
          <div data-id="element-49" data-mp="2zzrb3am1oqc0">
            <h3 className="text-xl font-semibold tracking-tight sm:text-2xl" data-id="element-50" data-mp="2zy6gxm3n79eo">{title}</h3>
            <p className="mt-1.5 max-w-md text-[15px] leading-relaxed text-canvas/75" data-id="element-51" data-mp="1slwmulzfel8q">{text}</p>
          </div>
          {stat && <div className="hidden shrink-0 text-right sm:block" data-id="element-52" data-mp="1oihviz61eifz">
              <div className="font-display text-4xl font-semibold tracking-tight text-volt" data-id="element-53" data-mp="3a0xden23qc0o">{stat.value}</div>
              <div className="text-[13px] text-canvas/65" data-id="element-54" data-mp="3ez8pz5js70ml">{stat.label}</div>
            </div>}
        </div>
      </div>
    </article>;
}
export function Benefits() {
  return <section className="mx-auto max-w-[1440px] px-4 py-24 sm:px-6 lg:px-10 lg:py-32" data-id="element-55" data-mp="351cgei6hsdql">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-56" data-mp="2ra7bb0kcut8v">
        <h2 className="max-w-4xl text-4xl font-semibold leading-[1.04] tracking-tightest text-ink sm:text-5xl lg:text-[56px]" data-id="element-57" data-mp="2w1fnu5gzeuq9">
          Minder afhankelijk van het net.
          <br className="hidden sm:block" data-id="element-58" data-mp="2heckhi5z9rv0" /> <span className="text-ink-muted" data-id="element-59" data-mp="2mbcsvzqav6pa">Meer grip op je rekening.</span>
        </h2>
        <p className="max-w-sm text-lg leading-relaxed text-ink-soft" data-id="element-60" data-mp="28buzt85z17a4">
          Een thuisbatterij maakt van je zonnepanelen een complete energie-installatie.
        </p>
      </div>

      <div className="mt-14 grid gap-4 lg:h-[780px] lg:grid-cols-12 lg:grid-rows-2" data-id="element-61" data-mp="2dd0sj5zmsujn">
        <ImageTile className="lg:col-span-7 lg:row-span-2" image={images.livingEvening} alt="Gezin in een warme woonkamer in de avond" title="’s Avonds op eigen zonnestroom" text="Wat je overdag opwekt, gebruik je als het donker is. Koken, wassen, tv — gewoon op je eigen dak." stat={{
        value: '70%',
        label: 'zelfvoorzienend'
      }} data-id="element-62" data-mp="iw0s9mu2do2r" />
        <ImageTile className="lg:col-span-5" image={images.solarRoof} alt="Zwarte zonnepanelen op een pannendak" title="Geen terugleverkosten" text="Je levert minder terug aan het net, dus je betaalt ook geen boete voor je eigen zonnestroom." data-id="element-63" data-mp="11ssjqjjrf9hw" />
        <article className="grid overflow-hidden rounded-[28px] bg-forest text-canvas sm:grid-cols-2 lg:col-span-5" data-id="element-64" data-mp="ntj6nsquovi5">
          <div className="flex flex-col p-7" data-id="element-65" data-mp="3dgrx0xwvafz3">
            <h3 className="text-2xl font-semibold tracking-tight" data-id="element-66" data-mp="38j03y0khkntb">Laad je auto met je eigen zon</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-canvas/70" data-id="element-67" data-mp="1o31zmc9gcs0g">
              De batterij stuurt je laadpaal aan zodat je auto ’s nachts oplaadt met opgeslagen of goedkope stroom.
            </p>
            <div className="mt-auto pt-8" data-id="element-68" data-mp="1x1vtvvzb96au">
              <div className="font-display text-4xl font-semibold tracking-tight text-volt" data-id="element-69" data-mp="1x0ukrx1uutvr">€ 0,08</div>
              <div className="text-[13px] text-canvas/60" data-id="element-70" data-mp="26sh2mc8p7r7h">gemiddeld per kWh laden</div>
            </div>
          </div>
          <img src={images.evDriveway} alt="Elektrische auto laadt op bij een woning" className="h-64 w-full object-cover sm:h-full" data-id="element-71" data-mp="2br21o8c7s4uc" />
        </article>
      </div>
    </section>;
}